import { filtersHelper } from '@/utils';

export const notificationModel = (data = {}) => ({
    uuid: data.uuid,
    code: data.code || '',
    name: data.name || '',
    title: data.title || '',
    longDescription: data.long_description || '',
    description: data.description || '',
    emailSubject: data.email_subject || '',
    emailHtmlContent: data.email_html_content || '',
    type: data.type == null ? null : Number(data.type),
    isActive: data.is_active == null ? true : Number(data.is_active) === 1,
    redirectPage: data.redirect_page || '',
    redirectPageParameters: data.redirect_page_prmtr || [],
    whatsappTemplateName: data.whatsapp_template_name || '',
    whatsappTemplateLanguage: data.whatsapp_template_language || '',
    whatsappTemplateParameterKeys: data.whatsapp_template_prmtr_keys || [],
    icon: data.icon || null,
    channels: data.channels || [],
    iconUUID: data.icon_uuid || data.icon?.uuid || '',
    channelUUIDs: data.channel_uuids || (data.channels || []).map((channel) => channel.uuid),
    createdBy: data.created_by,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    updatedBy: data.updated_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
});
